import React, { useEffect, useState } from "react";
import { Wrapper } from "./AlertPayment.style";
import PropTypes from "prop-types";
import { getPropertiesFNA } from "./AlertPayment.constants";
const AlertPayment = _ref => {
  let {
    nid,
    isMx = true
  } = _ref;
  const [show, setShow] = useState(false);
  useEffect(() => {
    getPropertiesFNA(isMx).then(response => {
      if (!response) return;
      const {
        sections
      } = response.data;
      const [{
        extra_data,
        is_active
      }] = sections;
      setShow(!is_active || extra_data.includes(nid));
    });
  }, []);
  return show && /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("p", null, "*Este valor aplica s\xF3lo para el pago de la totalidad del inmueble de contado. Podr\xEDa aumentar si se elige financiaci\xF3n u otra forma de pago."));
};
AlertPayment.propTypes = {
  nid: PropTypes.number.isRequired
};
export default AlertPayment;